import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../../../components/Administration/General/Admin-breadcrumb'
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAquaaEvaluationsDelete, getAquaaIcedEvaluationsData, getSavedEvaluationFormData, saveEvaluationData, updateAquaaEvaluationsDeleteStart } from '../../../actions/Applications/aquaa.action';
import deleteIcon from './../../../assets/onboard-images/Delete_Icon.png'
import { AssignedAccountsTblPopUp } from '../../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';
import RefreshIcon from './../../../assets/images/Reset_Icon.png';


const AquaaAdminEvaluationsDelete = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const aquaaEvaluationsDeleteData = useSelector((state)=> state.aquaaReducer.aquaaEvaluationsDeleteData);
    const savedevaluationFormData = useSelector((state) => state.aquaaReducer.savedevaluationFormData);
    const aquaaIcedEvaluationsData = useSelector((state) => state.aquaaReducer.aquaaIcedEvaluationsData);
    
    const [isEvaluationFetched, setIsEvaluationFetched] = useState(false);
    const[saveEvaluationID,setSaveEvaluationID] = useState();
    const [model, setModel] = useState(false);
    const [deleteId,setDeleteId] = useState('') 
    const [formData, setFormData] = useState({
              ticketNo: ''
            });
 const RoleId = localStorage.getItem('Role_id');
    useEffect(()=>{
        dispatch(getAquaaEvaluationsDelete('','',RoleId));
        dispatch(getAquaaIcedEvaluationsData(RoleId))
    },[dispatch,RoleId])

     console.log('aquaaIcedEvaluationsData',aquaaIcedEvaluationsData)
      const aquaaEvaluationDeleteTableData = aquaaEvaluationsDeleteData && aquaaEvaluationsDeleteData.length > 0 ? (aquaaEvaluationsDeleteData[0]?.Evaluations) : [];

      const contactIdHandler = (row) => {
          if (row.EvaluationID && !isEvaluationFetched) {
            dispatch(getSavedEvaluationFormData(row.EvaluationID)); // Fetch the evaluation data for this contact
            setIsEvaluationFetched(true); // Mark that the data is being fetched
            setSaveEvaluationID(row.EvaluationID)
           
          }
        };

        useEffect(() => {
            if (
              savedevaluationFormData &&
              Array.isArray(savedevaluationFormData) &&
              savedevaluationFormData.length > 0 && isEvaluationFetched && 
              saveEvaluationID === savedevaluationFormData?.[0]?.AccountDetails?.[0]?.EvaluationID
            ) {
              // Save the evaluation data to the store (if needed)
              dispatch(saveEvaluationData(savedevaluationFormData));
        
              setIsEvaluationFetched(false)
        
              history.push('/evaluationform');
            
        
            }
          }, [savedevaluationFormData,dispatch,history,isEvaluationFetched,saveEvaluationID]);
         
          const deleteHandler = (data) =>{
            console.log('data',data)
            setModel(true);
            setDeleteId(data.EvaluationID)
          }
          const deleteYesHandler = () =>{
            dispatch(updateAquaaEvaluationsDeleteStart([{"EvaluationID": deleteId}]));
            setModel(false);
            dispatch(getAquaaEvaluationsDelete('',formData.ticketNo,RoleId))
            }

          const handleFormDataChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value, // Update specific key in formData
    }));
  };

  const handleSearchAccount = () =>{
   dispatch(getAquaaEvaluationsDelete('',formData.ticketNo,RoleId))

  }

  const tableHeaders = aquaaEvaluationDeleteTableData.length > 0 
  ? Object.keys(aquaaEvaluationDeleteTableData[0]).filter(header => 
      header !== 'Delete'  // Exclude 'Delete' from headers initially
    ).concat('Delete') // Add 'Delete' at the end
  : [];


  // const IcedEvaluationstableHeaders = aquaaIcedEvaluationsData.length > 0 
  // ? Object.keys(aquaaEvaluationDeleteTableData[0]) 
  // : [];

  const IcedEvaluationstableHeaders = aquaaIcedEvaluationsData.length > 0 
  ? Object.keys(aquaaIcedEvaluationsData[0]).filter(header => 
      !['AgentID', 'AccountID', 'Ipaddress'].includes(header)
    )
  : [];

const deleteID = aquaaEvaluationsDeleteData?.[0]?.DeleteYesNo?.[0]?.Operation;
console.log('deleteID',deleteID)

const handleRefresh = () => {
  setFormData({ ticketNo: '' }); // Clear input
  dispatch(getAquaaEvaluationsDelete('', '', RoleId)); // Re-fetch all evaluations
};
    
  return (
    <div>
        <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={false}
            label3='AQuAA Data' />

        <main style={{display:'flex',gap:'40px',marginTop:'40px',alignItems:'center'}}>
             <div className='container-one' >
            <div><label>Enter Ticket Number / Evaluator Email / Agent Email </label></div> 
                        <input
                          type="text"
                          placeholder="Example: 0123456789"
                          value={formData.ticketNo}
                          onChange={(e) => handleFormDataChange('ticketNo', e.target.value)}  // Bind to formData.ticketNumber
                        />
                      </div>
                     
                      <div className='btn_adduser' onClick={handleSearchAccount}>Search</div>
                      <div className='btn_adduser' onClick={()=>{window.location.href = `${process.env.REACT_APP_BASE_URL}api/usp/AQuAAPrintEvaluations?RoleId=${RoleId}&format=excel&filename=AQuAAPrintEvaluations_Excel.xlsx`}}>Export</div>
                      <div style={{cursor:'pointer'}} ><img src={RefreshIcon} onClick={handleRefresh} alt='refresh' width='20px' height='20px'/></div>
        </main>

       <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title" style={{fontSize:'20px'}}> Submitted Evaluations </div>
      </section> 
      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {tableHeaders.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {aquaaEvaluationDeleteTableData && aquaaEvaluationDeleteTableData.length > 0 ? (
              aquaaEvaluationDeleteTableData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {tableHeaders.map((col, colIndex) => {
                    const cellData = row[col]; // Get the data for this column in the current row

                    if (col === 'EvaluationDate') {
                      return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                    }

                    if (col === "Delete") {
            return (
              <td key={colIndex}>
                {row[col] === "1" ? (
                  <img src={deleteIcon} alt="Delete" onClick={() => deleteHandler(row)} style={{cursor:'pointer'}}/>
                ) : null}
              </td>
            );
          }

                    return (
                      <td key={colIndex} style={col === 'EvaluationID' ? { cursor: 'pointer', color: '#004aac' } : null}>
                        {col === 'EvaluationID' ? <div onClick={() => { contactIdHandler(row) }}>{cellData}</div> : (cellData)}
                      </td>
                    );
                  })}
{/* {cellData?.Delete === 1 ? (
        <td>
          <img src={deleteIcon} alt="Delete" onClick={() => deleteHandler(row)} />
        </td>
      ) : null}               
       */}
        </tr>
              ))
            ) : (
              <tr>
               <td colSpan={tableHeaders.length + 1}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available, please try different filters or contact the admin.
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <section className="App_Layout" style={{ marginBottom: '20px' }}>
        <div className="Applications_Title" style={{fontSize:'20px'}}> ICED Evaluations </div>
      </section> 
      <div className="aquaa-table-container">
        <table className="aquaa-table">
          <thead>
            <tr>
              {IcedEvaluationstableHeaders.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {aquaaIcedEvaluationsData && aquaaIcedEvaluationsData.length > 0 ? (
              aquaaIcedEvaluationsData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {IcedEvaluationstableHeaders.map((col, colIndex) => {
                    const cellData = row[col]; // Get the data for this column in the current row

                    if (col === 'date') {
                      return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                    }

                    return (
                      <td key={colIndex}>
                         {cellData}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
               <td colSpan={tableHeaders.length + 1}>
                  <section>
                    <div className="noData-para" style={{ marginTop: 0 }}>
                      <div style={{ marginTop: 30 }}>
                        No data available, please try different filters or contact the admin.
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

       {model &&
                <AssignedAccountsTblPopUp isOpen={model} setShowModal={setModel}>
                <main className='Sure_text'>Are you sure you want to delete the Evaluation</main>
                      <main style={{display:'flex',justifyContent:'center'}}>   <div className='btn_adduser' onClick={()=>deleteYesHandler()}>Delete</div>
                         <div className='btn_canceluser' onClick={()=>setModel(false)}>Cancel</div></main>

                </AssignedAccountsTblPopUp>
               }
    </div>

    
  )

  
}

export default AquaaAdminEvaluationsDelete